import { useDebouncedCallback } from 'use-debounce';

const useDebounce = useDebouncedCallback;
export default useDebounce;
